<template>
    <ion-page>
      <ion-loading :is-open="isLoadingMemberCard" :duration="2000" message="ポイント 取得中..."> </ion-loading>
      <ion-content class="ion-padding" v-if="canWithdraw">
        <div v-if="progress_step == 0">
          <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">退会手続き</ion-header>
          <div style="border: red 1px solid" class="ion-text-center">
            <img class="ion-margin-top" style="height: 60px" alt='' :src="warningIcon"/>
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">退会手続きの前にご確認ください</ion-header>
            <p class="ion-padding-horizontal" v-if="isEcUnitedUser">
              会員を退会されると、現在保有されているポイントやクーポン、登録済みのお客様情報（オンラインショップの情報含む）全ての情報が削除されます。
            </p>
            <p class="ion-padding-horizontal" v-else>
              会員を退会されると、現在保有されているポイントやクーポン、登録済みのお客様情報等、すべての情報が削除されます。
            </p>
          </div>
          <div style="color: white" class="danger-card">
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">お客様の保有ポイント</ion-header>
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">
              <span class="point-font">{{ point }}</span> pt
            </ion-header>
            <div style="border: white 1px solid" class="ion-margin-horizontal"></div>
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center ion-padding-horizontal">退会するとポイントがご利用できなくなりますが、退会されますか？</ion-header>
          </div>
          <ion-button class="ion-margin-top danger-button" @click="progress_step = 1" expand="block">退会する ></ion-button>
          <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline"  @click="goBackToMembershipCard">会員証に戻る ></ion-button>
        </div>
        <div v-else-if="progress_step == 1">
          <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">退会手続き</ion-header>
          <div style="border: red 1px solid" class="ion-text-center">
            <img class="ion-margin-top" style="height: 60px" alt='' :src="warningIcon"/>
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">本当に退会しますか？</ion-header>
          </div>
          <div style="color: white" class="danger-card">
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">お客様の保有ポイント</ion-header>
            <ion-header class="ion-margin-bottom ion-margin-top ion-text-center">
              <span class="point-font">{{ point }}</span> pt
            </ion-header>
            <div style="border: white 1px solid" class="ion-margin-horizontal"></div>
            <ion-header class="ion-margin-top ion-text-center ion-padding-horizontal">アカウント削除すると、全ての情報が削除され、元に戻すことはできません。<br/>本当に退会してもよろしいでしょうか？</ion-header>
            <div style="display: flex; font-size: 14px; justify-content: center" class="ion-padding-horizontal font-bold" v-if="isEcUnitedUser">
              <span>※</span>
              <span>オンラインショップにご登録されている情報も全て削除されます。</span>
            </div>
          </div>
          <ion-button class="ion-margin-top danger-button" @click="runWithdrawal" expand="block">退会する ></ion-button>
          <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline"  @click="goBackToMembershipCard">会員証に戻る ></ion-button>
        </div>
        <div v-else-if="progress_step == 2">
          <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">退会が完了しました</ion-header>
          <div>
            <ion-header class="ion-margin-bottom ion-margin-top">会員様向けに既に配信設定がされているお知らせが数通届く場合がございますので、ご了承ください。</ion-header>
          </div>
        </div>
      </ion-content>
    </ion-page>
</template>


<script setup lang="ts">
import warningIcon from '@/assets/chiyoda_icon/warning.png'
import {
    IonPage,
    IonHeader,
    IonContent,
    IonButton, IonLoading, onIonViewWillEnter,

} from '@ionic/vue';
import {ref} from 'vue';
import axiosService from '../../../utils/AxiosService'
import * as action from "@/actions/member-card";
import {goBackToMembershipCard} from "@/helpers/platform";

const progress_step = ref(0)
const point = ref(0);
const isEcUnitedUser = ref(false);
const isLoadingMemberCard = ref(false)
const canWithdraw = ref(false);

async function runWithdrawal() {
    //退会APIを叩く
    axiosService.post('/other/withdrawal').then(async(response) => {
      progress_step.value = 2;
    }).catch((err) => {
        console.error(err)
    })

}

onIonViewWillEnter(async () => {
  canWithdraw.value = await axiosService.get('/ec/can-withdraw')
  if(canWithdraw.value) {
    await fetchMemberCard()
  }
})

async function fetchMemberCard(): Promise<void> {
  isLoadingMemberCard.value = true
  try {
    const response = await action.memberCard()
    point.value = response.data?.user?.point ?? 0;
    isEcUnitedUser.value = response.data?.user?.is_ec_united_user ?? false;
  } catch (err) {
    throw new Error('残りのポイントの取得に失敗しました。')
  }
  isLoadingMemberCard.value = false
}
</script>

<style scoped>
 .custom-helper-text {
   font-size: 0.75rem;
   color: var(--ion-color-step-550, #737373);
 }
 .point-font {
   font-size: 1.75rem;
   font-weight: bold;
 }
</style>
